import React, { useMemo, useState } from "react";
import * as XLSX from "xlsx";

/*
  Cambiar a false cuando ya quieras activar OCR real.
  Mientras esté en true, NO llama OCR, NO llama OpenAI y NO consume créditos.
*/
const OCR_MODO_DEMO = true;

/*
  Si el OCR real falla, se detiene todo el proceso.
  No llena tabla, no deja registros parciales y no genera información.
*/
const OCR_DETENER_PROCESO_SI_FALLA = true;

/*
  Para activar el modo real después:
  1. Cambiar OCR_MODO_DEMO a false.
  2. Configurar tokenOpenIAEndpoint, accessTokenInterno y ocrSpaceApiKey.
  3. Lo recomendable es que accessTokenInterno y ocrSpaceApiKey vivan en backend.
*/
const OCR_CONFIG = {
  tokenOpenIAEndpoint: "https://api.checkmark.mx/obtener/token/openia",
  accessTokenInterno: "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
  ocrSpaceApiKey: "DPD8VZYKE82MX",
  language: "spa",
  openAiModel: "gpt-4o-mini",
};

const FacturacionFacturas = () => {
  const [facturasPdf, setFacturasPdf] = useState([]);
  const [procesando, setProcesando] = useState(false);
  const [procesado, setProcesado] = useState(false);
  const [progreso, setProgreso] = useState(0);
  const [pasoActual, setPasoActual] = useState("");
  const [errores, setErrores] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstatus, setFiltroEstatus] = useState("Todos");
  const [facturasProcesadas, setFacturasProcesadas] = useState([]);

  const puedeProcesar = facturasPdf.length > 0;

  const formatMoney = (value) => {
    const number = Number(value || 0);

    return number.toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
    });
  };

  const limpiarNumero = (value) => {
    if (value === null || value === undefined) return 0;

    const limpio = String(value)
      .replace(/\$/g, "")
      .replace(/,/g, "")
      .replace(/\s/g, "")
      .trim();

    const number = Number(limpio);

    return Number.isNaN(number) ? 0 : number;
  };

  const normalizarTexto = (value) => {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toUpperCase();
  };

  const validarArchivoPdf = (file) => {
    if (!file) return false;

    const extension = file.name.split(".").pop().toLowerCase();

    return extension === "pdf";
  };

  const obtenerFechaArchivo = () => {
    const fecha = new Date();

    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const day = String(fecha.getDate()).padStart(2, "0");
    const hours = String(fecha.getHours()).padStart(2, "0");
    const minutes = String(fecha.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}_${hours}-${minutes}`;
  };

  const crearFacturaBase = (file, index, datos = {}) => {
    return {
      id: `${Date.now()}-${index}-${file?.name || "factura"}`,
      archivo: file?.name || "",
      agencia: "",
      fechaFactura: "",
      fechaTimbrado: "",
      facturaUnidad: "",
      folioCfdi: "",
      cliente: "",
      rfcCliente: "",
      vendedor: "",
      marca: "",
      modelo: "",
      tipo: "",
      vehiculo: "",
      vin: "",
      inventario: "",
      pedido: "",
      motor: "",
      segmento: "",
      combustible: "",
      colorExterior: "",
      colorInterior: "",
      metodoPago: "",
      formaPago: "",
      condiciones: "",
      subtotal: 0,
      iva: 0,
      total: 0,
      tipoProducto: "",
      descripcionProducto: "",
      estatus: "Revisar",
      observacion: "Información pendiente de revisión",
      ...datos,
    };
  };

  const resetProceso = () => {
    setProcesando(false);
    setProcesado(false);
    setProgreso(0);
    setPasoActual("");
    setBusqueda("");
    setFiltroEstatus("Todos");
    setFacturasProcesadas([]);
  };

  const handleFacturasChange = (event) => {
    const files = Array.from(event.target.files || []);
    const erroresTemporales = [];

    const archivosValidos = files.filter((file) => {
      const esValido = validarArchivoPdf(file);

      if (!esValido) {
        erroresTemporales.push(
          `El archivo "${file.name}" no es PDF y fue omitido.`,
        );
      }

      return esValido;
    });

    setFacturasPdf(archivosValidos);
    setErrores(erroresTemporales);
    resetProceso();
  };

  const limpiarArchivos = () => {
    setFacturasPdf([]);
    setErrores([]);
    resetProceso();

    const inputs = document.querySelectorAll(".facturas-file-input");

    inputs.forEach((input) => {
      input.value = "";
    });
  };

  const obtenerFacturaSimulada = (file, index) => {
    const nombreArchivo = normalizarTexto(file.name);

    if (nombreArchivo.includes("41142")) {
      return crearFacturaBase(file, index, {
        agencia: "SPANICAR MEXICO",
        fechaFactura: "02/03/2026",
        fechaTimbrado: "02/03/2026 19:44:47",
        facturaUnidad: "V000041142",
        folioCfdi: "c4dc71f8-425a-48be-81b9-76eeb203f1a9",
        cliente: "GUTIERREZ GONZALEZ LIZBETH ASTRID",
        rfcCliente: "XAXX010101000",
        vendedor: "MARIA DEL ROCIO VAZQUEZ NAVARRETE",
        marca: "NISSAN",
        modelo: "2025",
        tipo: "KICKS E-POWER",
        vehiculo:
          "KICKS PLAY E-POWER PLATINUM MOTOR ELECTRICO E-REV 5 PTAS",
        vin: "MNTFP5CP5S6017459",
        inventario: "201915517",
        pedido: "71212",
        motor: "HR12537858C",
        segmento: "FAMILIAR",
        combustible: "ELECTRICO",
        colorExterior: "AZUL ESPACIAL BITO",
        colorInterior: "NEGRO",
        metodoPago: "PPD",
        formaPago: "99",
        condiciones: "02 CREDINISSAN MENUDEO",
        subtotal: 434396.55,
        iva: 69503.45,
        total: 503900,
        tipoProducto: "Unidad Nueva",
        descripcionProducto: "Factura de unidad",
        estatus: "Procesada",
        observacion: "Información extraída correctamente",
      });
    }

    if (nombreArchivo.includes("41103")) {
      return crearFacturaBase(file, index, {
        agencia: "SPANICAR MEXICO",
        fechaFactura: "28/02/2026",
        fechaTimbrado: "28/02/2026 20:34:04",
        facturaUnidad: "V000041103",
        folioCfdi: "85a62a6d-4faa-4c25-8414-3c6acfc53f00",
        cliente: "CHAVEZ PATRICIO EVA",
        rfcCliente: "XAXX010101000",
        vendedor: "VICTOR HUGO MINOR ALCARAZ",
        marca: "NISSAN",
        modelo: "2026",
        tipo: "MARCH K13",
        vehiculo: "MARCH ADVANCE T/MAN",
        vin: "3N1CK3CEXTL201639",
        inventario: "201915331",
        pedido: "71196",
        motor: "HR16475441P",
        segmento: "COMPACTO",
        combustible: "GASOLINA",
        colorExterior: "GRIS",
        colorInterior: "NEGRO",
        metodoPago: "PPD",
        formaPago: "99",
        condiciones: "02 CREDINISSAN MENUDEO",
        subtotal: 279224.14,
        iva: 44675.86,
        total: 323900,
        tipoProducto: "Unidad Nueva",
        descripcionProducto: "Factura de unidad",
        estatus: "Procesada",
        observacion: "Información extraída correctamente",
      });
    }

    return crearFacturaBase(file, index, {
      tipoProducto: "Unidad Nueva",
      descripcionProducto: "Factura de unidad",
      estatus: "Revisar",
      observacion: "No se encontró una plantilla de extracción para esta factura",
    });
  };

  const actualizarPaso = async (texto, porcentaje, tiempo = 450) => {
    setPasoActual(texto);
    setProgreso(porcentaje);

    await new Promise((resolve) => {
      setTimeout(resolve, tiempo);
    });
  };

  const obtenerTokenOpenIA = async () => {
    if (!OCR_CONFIG.accessTokenInterno) {
      throw new Error("Falta configurar accessTokenInterno para OCR real.");
    }

    const formData = new FormData();

    formData.append("access_token", OCR_CONFIG.accessTokenInterno);

    const res = await fetch(OCR_CONFIG.tokenOpenIAEndpoint, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!res.ok || data.statusCode !== 200) {
      throw new Error(data.message || "No se pudo obtener el token de OpenIA");
    }

    const tokenOpenIA = data?.data?.token_openia?.access_token;

    if (!tokenOpenIA) {
      throw new Error("El servicio no devolvió access_token de OpenIA");
    }

    return tokenOpenIA;
  };

  const extraerTextoOCRSpace = async (file) => {
    if (!OCR_CONFIG.ocrSpaceApiKey) {
      throw new Error("Falta configurar ocrSpaceApiKey para OCR real.");
    }

    const formDataOCR = new FormData();

    formDataOCR.append("apikey", OCR_CONFIG.ocrSpaceApiKey);
    formDataOCR.append("file", file);
    formDataOCR.append("language", OCR_CONFIG.language || "spa");
    formDataOCR.append("isOverlayRequired", "false");
    formDataOCR.append("detectOrientation", "true");
    formDataOCR.append("scale", "true");

    const ocrRes = await fetch("https://apipro1.ocr.space/parse/image", {
      method: "POST",
      body: formDataOCR,
    });

    const ocrJson = await ocrRes.json();

    if (!ocrRes.ok || ocrJson?.IsErroredOnProcessing) {
      throw new Error(
        ocrJson?.ErrorMessage?.[0] ||
          "No se pudo extraer texto del PDF con OCR.",
      );
    }

    const rawText = ocrJson?.ParsedResults?.[0]?.ParsedText || "";

    if (!rawText.trim()) {
      throw new Error("OCR no devolvió texto útil.");
    }

    return rawText;
  };

  const extraerDatosFacturaConOpenAI = async (rawText, tokenOpenIA) => {
    const texto = rawText.replace(/(\r\n|\n|\r)/g, " ").trim();

    const openaiRes = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${tokenOpenIA}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: OCR_CONFIG.openAiModel,
        max_tokens: 900,
        temperature: 0.1,
        messages: [
          {
            role: "user",
            content:
              "Genera SOLO un JSON válido, sin markdown, con un objeto llamado datos. " +
              "El objeto datos debe incluir estas llaves exactas: agencia, fechaFactura, fechaTimbrado, facturaUnidad, folioCfdi, cliente, rfcCliente, vendedor, marca, modelo, tipo, vehiculo, vin, inventario, pedido, motor, segmento, combustible, colorExterior, colorInterior, metodoPago, formaPago, condiciones, subtotal, iva, total. " +
              "Si un dato no existe, regresa cadena vacía o 0 según corresponda. Texto de factura: " +
              texto,
          },
        ],
      }),
    });

    const openaiData = await openaiRes.json();

    if (!openaiRes.ok) {
      throw new Error(
        openaiData?.error?.message || "OpenIA no pudo procesar el texto.",
      );
    }

    const contenidoModelo = openaiData?.choices?.[0]?.message?.content || "";

    if (!contenidoModelo) {
      throw new Error("OpenIA no devolvió contenido.");
    }

    let parsed = {};

    try {
      const match = contenidoModelo.match(/\{[\s\S]*\}/);
      parsed = JSON.parse(match ? match[0] : contenidoModelo);
    } catch {
      throw new Error("OpenIA devolvió una respuesta inválida.");
    }

    return parsed?.datos || {};
  };

  const normalizarFacturaOCR = (file, index, datos = {}) => {
    const facturaUnidad =
      datos.facturaUnidad ||
      datos.FacturaUnidad ||
      datos.folio ||
      datos.Folio ||
      "";

    const subtotal = limpiarNumero(datos.subtotal || datos.Subtotal);
    const iva = limpiarNumero(datos.iva || datos.IVA);
    const total = limpiarNumero(datos.total || datos.Total);

    const cliente = datos.cliente || datos.Cliente || "";
    const vin = datos.vin || datos.VIN || "";

    const faltantes = [];

    if (!facturaUnidad) faltantes.push("factura");
    if (!cliente) faltantes.push("cliente");
    if (!vin) faltantes.push("VIN");
    if (!total) faltantes.push("total");

    if (faltantes.length) {
      throw new Error(
        `El OCR no detectó todos los campos requeridos: ${faltantes.join(
          ", ",
        )}.`,
      );
    }

    return crearFacturaBase(file, index, {
      agencia: datos.agencia || datos.Agencia || "",
      fechaFactura: datos.fechaFactura || datos.FechaFactura || "",
      fechaTimbrado: datos.fechaTimbrado || datos.FechaTimbrado || "",
      facturaUnidad,
      folioCfdi: datos.folioCfdi || datos.FolioCfdi || datos.CFDI || "",
      cliente,
      rfcCliente: datos.rfcCliente || datos.RfcCliente || "",
      vendedor: datos.vendedor || datos.Vendedor || "",
      marca: datos.marca || datos.Marca || "",
      modelo: datos.modelo || datos.Modelo || "",
      tipo: datos.tipo || datos.Tipo || "",
      vehiculo: datos.vehiculo || datos.Vehiculo || "",
      vin,
      inventario: datos.inventario || datos.Inventario || "",
      pedido: datos.pedido || datos.Pedido || "",
      motor: datos.motor || datos.Motor || "",
      segmento: datos.segmento || datos.Segmento || "",
      combustible: datos.combustible || datos.Combustible || "",
      colorExterior: datos.colorExterior || datos.ColorExterior || "",
      colorInterior: datos.colorInterior || datos.ColorInterior || "",
      metodoPago: datos.metodoPago || datos.MetodoPago || "",
      formaPago: datos.formaPago || datos.FormaPago || "",
      condiciones: datos.condiciones || datos.Condiciones || "",
      subtotal,
      iva,
      total,
      tipoProducto: "Unidad Nueva",
      descripcionProducto: "Factura de unidad",
      estatus: "Procesada",
      observacion: "Información extraída correctamente",
    });
  };

  const escanearPdfYExtraerFactura = async (file, index) => {
    if (OCR_MODO_DEMO) {
      return obtenerFacturaSimulada(file, index);
    }

    const tokenOpenIA = await obtenerTokenOpenIA();
    const rawText = await extraerTextoOCRSpace(file);
    const datos = await extraerDatosFacturaConOpenAI(rawText, tokenOpenIA);

    return normalizarFacturaOCR(file, index, datos);
  };

  const procesarFacturas = async () => {
    if (!puedeProcesar) {
      setErrores(["Para procesar necesitas cargar al menos una factura PDF."]);
      return;
    }

    try {
      setProcesando(true);
      setProcesado(false);
      setErrores([]);
      setFacturasProcesadas([]);
      setProgreso(0);

      await actualizarPaso("Preparando lectura de facturas", 15, 400);

      const resultados = [];

      for (let i = 0; i < facturasPdf.length; i += 1) {
        const file = facturasPdf[i];
        const porcentajeBase =
          20 + Math.round(((i + 1) / facturasPdf.length) * 55);

        await actualizarPaso(`Analizando ${file.name}`, porcentajeBase, 600);

        try {
          const factura = await escanearPdfYExtraerFactura(file, i);
          resultados.push(factura);
        } catch (errorFactura) {
          console.error("Error al procesar factura:", errorFactura);

          if (OCR_DETENER_PROCESO_SI_FALLA) {
            throw new Error(
              `No está funcionando el proceso de lectura de facturas. No se generó información. Detalle: ${
                errorFactura?.message || "Error no identificado"
              }`,
            );
          }
        }
      }

      await actualizarPaso("Validando información extraída", 85, 500);

      if (!resultados.length) {
        throw new Error(
          "No se pudo generar información a partir de las facturas cargadas.",
        );
      }

      await actualizarPaso("Generando tabla de facturas", 100, 500);

      setFacturasProcesadas(resultados);
      setProcesando(false);
      setProcesado(true);
      setPasoActual("Proceso finalizado");
    } catch (error) {
      console.error(error);

      setProcesando(false);
      setProcesado(false);
      setFacturasProcesadas([]);
      setProgreso(0);
      setPasoActual("");

      setErrores([
        error?.message ||
          "No está funcionando el proceso de lectura de facturas. Intenta más tarde.",
      ]);
    }
  };

  const facturasFiltradas = useMemo(() => {
    return facturasProcesadas.filter((item) => {
      const coincideEstatus =
        filtroEstatus === "Todos" || item.estatus === filtroEstatus;

      const textoBusqueda = busqueda.trim().toLowerCase();

      const coincideBusqueda =
        textoBusqueda === "" ||
        item.facturaUnidad.toLowerCase().includes(textoBusqueda) ||
        item.cliente.toLowerCase().includes(textoBusqueda) ||
        item.vin.toLowerCase().includes(textoBusqueda) ||
        item.vehiculo.toLowerCase().includes(textoBusqueda) ||
        item.vendedor.toLowerCase().includes(textoBusqueda) ||
        item.archivo.toLowerCase().includes(textoBusqueda);

      return coincideEstatus && coincideBusqueda;
    });
  }, [facturasProcesadas, filtroEstatus, busqueda]);

  const resumen = useMemo(() => {
    const totalFacturas = facturasProcesadas.length;

    const procesadas = facturasProcesadas.filter(
      (item) => item.estatus === "Procesada",
    ).length;

    const revisar = facturasProcesadas.filter(
      (item) => item.estatus === "Revisar",
    ).length;

    const totalImporte = facturasProcesadas.reduce(
      (total, item) => total + Number(item.total || 0),
      0,
    );

    const totalSubtotal = facturasProcesadas.reduce(
      (total, item) => total + Number(item.subtotal || 0),
      0,
    );

    const totalIva = facturasProcesadas.reduce(
      (total, item) => total + Number(item.iva || 0),
      0,
    );

    return {
      totalFacturas,
      procesadas,
      revisar,
      totalImporte,
      totalSubtotal,
      totalIva,
    };
  }, [facturasProcesadas]);

  const getBadgeClass = (estatus) => {
    switch (estatus) {
      case "Procesada":
        return "badge bg-success text-white";
      case "Revisar":
        return "badge bg-warning text-dark";
      default:
        return "badge bg-secondary text-white";
    }
  };

  const aplicarAnchosColumnas = (worksheet, anchos = []) => {
    worksheet["!cols"] = anchos.map((wch) => ({ wch }));
  };

  const aplicarFormatoMoneda = (worksheet, columnas = [], totalFilas = 0) => {
    columnas.forEach((columna) => {
      for (let row = 2; row <= totalFilas; row += 1) {
        const cellRef = `${columna}${row}`;

        if (worksheet[cellRef]) {
          worksheet[cellRef].t = "n";
          worksheet[cellRef].z = "$#,##0.00";
        }
      }
    });
  };

  const descargarExcel = () => {
    const registros = facturasFiltradas;

    if (!registros.length) {
      setErrores(["No hay facturas para descargar con los filtros aplicados."]);
      return;
    }

    const datosExcel = registros.map((row) => ({
      Agencia: row.agencia,
      "Fecha Factura": row.fechaFactura,
      "Nota Cargo o Factura": row.facturaUnidad,
      "Tipo Producto": row.tipoProducto,
      "Descripción del Producto": row.descripcionProducto,
      Broker: "",
      Proveedor: "",
      Contrato: "",
      Póliza: "",
      "Nombre Vendedor": row.vendedor,
      "Nombre Cliente": row.cliente,
      Vehiculo: row.vehiculo,
      "No de Vin": row.vin,
      "Factura de unidad": row.facturaUnidad,
      "Monto Vendido/Financiado": Number(row.total || 0),
      "Utilidad Facturada": "",
      "Precio sin IVA": Number(row.subtotal || 0),
      "Costo Producto": "",
      "Utilidad Neta": "",
      RFC: row.rfcCliente,
      Marca: row.marca,
      Modelo: row.modelo,
      Tipo: row.tipo,
      Inventario: row.inventario,
      Pedido: row.pedido,
      Motor: row.motor,
      Segmento: row.segmento,
      Combustible: row.combustible,
      "Color Exterior": row.colorExterior,
      "Color Interior": row.colorInterior,
      "Método Pago": row.metodoPago,
      "Forma Pago": row.formaPago,
      "Folio CFDI": row.folioCfdi,
      Subtotal: Number(row.subtotal || 0),
      IVA: Number(row.iva || 0),
      Total: Number(row.total || 0),
      Archivo: row.archivo,
      Estatus: row.estatus,
      Observación: row.observacion,
    }));

    const totalSubtotal = registros.reduce(
      (total, item) => total + Number(item.subtotal || 0),
      0,
    );

    const totalIva = registros.reduce(
      (total, item) => total + Number(item.iva || 0),
      0,
    );

    const totalImporte = registros.reduce(
      (total, item) => total + Number(item.total || 0),
      0,
    );

    datosExcel.push({
      Agencia: "TOTALES",
      "Fecha Factura": "",
      "Nota Cargo o Factura": "",
      "Tipo Producto": "",
      "Descripción del Producto": "",
      Broker: "",
      Proveedor: "",
      Contrato: "",
      Póliza: "",
      "Nombre Vendedor": "",
      "Nombre Cliente": "",
      Vehiculo: "",
      "No de Vin": "",
      "Factura de unidad": "",
      "Monto Vendido/Financiado": Number(totalImporte.toFixed(2)),
      "Utilidad Facturada": "",
      "Precio sin IVA": Number(totalSubtotal.toFixed(2)),
      "Costo Producto": "",
      "Utilidad Neta": "",
      RFC: "",
      Marca: "",
      Modelo: "",
      Tipo: "",
      Inventario: "",
      Pedido: "",
      Motor: "",
      Segmento: "",
      Combustible: "",
      "Color Exterior": "",
      "Color Interior": "",
      "Método Pago": "",
      "Forma Pago": "",
      "Folio CFDI": "",
      Subtotal: Number(totalSubtotal.toFixed(2)),
      IVA: Number(totalIva.toFixed(2)),
      Total: Number(totalImporte.toFixed(2)),
      Archivo: "",
      Estatus: "",
      Observación: "",
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(datosExcel);

    aplicarAnchosColumnas(worksheet, [
      22, 16, 20, 18, 26, 18, 18, 18, 18, 32, 36, 42, 22,
      20, 22, 18, 18, 18, 18, 18, 14, 14, 18, 16, 16, 18,
      16, 18, 20, 18, 16, 16, 42, 18, 18, 18, 35, 16, 45,
    ]);

    const totalFilas = datosExcel.length + 1;

    aplicarFormatoMoneda(worksheet, ["O", "Q", "AH", "AI", "AJ"], totalFilas);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Facturas");

    XLSX.writeFile(
      workbook,
      `facturas_procesadas_${obtenerFechaArchivo()}.xlsx`,
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
        <div>
          <h1 className="page-header mb-1">Carga Facturas</h1>
          <p className="text-muted mb-0">
            Procesamiento de facturas PDF para generar información estructurada.
          </p>
        </div>

        <button className="btn btn-outline-secondary" onClick={limpiarArchivos}>
          Limpiar archivos
        </button>
      </div>

      {errores.length > 0 && (
        <div className="alert alert-warning">
          {errores.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      )}

      <div className="card border-0 mb-3">
        <div className="card-body">
          <div className="mb-3">
            <h5 className="card-title mb-1">Facturas PDF</h5>
            <p className="text-muted small mb-0">
              Selecciona una o varias facturas para procesar la información.
            </p>
          </div>

          <input
            type="file"
            className="form-control facturas-file-input"
            accept=".pdf"
            multiple
            onChange={handleFacturasChange}
          />

          {facturasPdf.length > 0 && (
            <div className="mt-3">
              <span className="badge bg-primary">
                {facturasPdf.length} archivo(s) cargado(s)
              </span>

              <div className="mt-3 small text-muted">
                {facturasPdf.slice(0, 4).map((file, index) => (
                  <div key={index} className="text-truncate">
                    {file.name}
                  </div>
                ))}

                {facturasPdf.length > 4 && (
                  <div>+ {facturasPdf.length - 4} archivo(s) más</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card border-0 mb-3">
        <div className="card-body">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h5 className="mb-1">Procesamiento</h5>
              <p className="text-muted mb-0">
                El sistema leerá las facturas y llenará la tabla con los campos
                encontrados.
              </p>
            </div>

            <button
              className="btn btn-primary"
              disabled={!puedeProcesar || procesando}
              onClick={procesarFacturas}
            >
              {procesando ? "Procesando..." : "Procesar facturas"}
            </button>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="border rounded p-3 mb-2 facturacion-summary-box">
                <div className="text-muted small">Archivos cargados</div>
                <h4 className="mb-0">{facturasPdf.length}</h4>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded p-3 mb-2 facturacion-summary-box">
                <div className="text-muted small">Procesadas</div>
                <h4 className="mb-0">{resumen.procesadas}</h4>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded p-3 mb-2 facturacion-summary-box">
                <div className="text-muted small">Por revisar</div>
                <h4 className="mb-0">{resumen.revisar}</h4>
              </div>
            </div>
          </div>

          {(procesando || procesado) && (
            <div className="mt-3">
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted small">{pasoActual}</span>
                <span className="text-muted small">{progreso}%</span>
              </div>

              <div className="progress" style={{ height: "8px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${progreso}%` }}
                  aria-valuenow={progreso}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {procesado && (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div className="card border-0 mb-3 facturacion-kpi-card">
                <div className="card-body">
                  <div className="text-muted small mb-1">
                    Facturas procesadas
                  </div>
                  <div className="facturacion-kpi-value">
                    {resumen.totalFacturas}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 mb-3 facturacion-kpi-card">
                <div className="card-body">
                  <div className="text-muted small mb-1">Subtotal</div>
                  <div className="facturacion-kpi-value facturacion-kpi-money">
                    {formatMoney(resumen.totalSubtotal)}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 mb-3 facturacion-kpi-card">
                <div className="card-body">
                  <div className="text-muted small mb-1">IVA</div>
                  <div className="facturacion-kpi-value facturacion-kpi-money">
                    {formatMoney(resumen.totalIva)}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 mb-3 facturacion-kpi-card">
                <div className="card-body">
                  <div className="text-muted small mb-1">Total facturado</div>
                  <div className="facturacion-kpi-value facturacion-kpi-money">
                    {formatMoney(resumen.totalImporte)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card border-0">
            <div className="card-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                <div>
                  <h5 className="mb-1">Facturas procesadas</h5>
                  <p className="text-muted mb-0">
                    Tabla generada a partir de los archivos cargados.
                  </p>
                </div>

                <div className="d-flex flex-wrap gap-2 ms-auto">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm px-3"
                    onClick={descargarExcel}
                  >
                    Descargar Excel
                  </button>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por factura, cliente, VIN, vendedor o archivo"
                    value={busqueda}
                    onChange={(event) => setBusqueda(event.target.value)}
                  />
                </div>

                <div className="col-md-3">
                  <select
                    className="form-select"
                    value={filtroEstatus}
                    onChange={(event) => setFiltroEstatus(event.target.value)}
                  >
                    <option value="Todos">Todos los estatus</option>
                    <option value="Procesada">Procesada</option>
                    <option value="Revisar">Revisar</option>
                  </select>
                </div>
              </div>

              <div className="table-responsive facturacion-table-wrapper">
                <table
                  className="table table-hover align-middle facturacion-table"
                  style={{ minWidth: "1750px" }}
                >
                  <thead className="facturacion-table-head">
                    <tr>
                      <th>Factura</th>
                      <th>Fecha</th>
                      <th>Cliente</th>
                      <th>Vendedor</th>
                      <th>Vehículo</th>
                      <th>VIN</th>
                      <th>Inventario</th>
                      <th>Pedido</th>
                      <th>Motor</th>
                      <th className="text-end">Subtotal</th>
                      <th className="text-end">IVA</th>
                      <th className="text-end">Total</th>
                      <th>CFDI</th>
                      <th>Archivo</th>
                      <th>Estatus</th>
                      <th>Observación</th>
                    </tr>
                  </thead>

                  <tbody>
                    {facturasFiltradas.length > 0 ? (
                      facturasFiltradas.map((row) => (
                        <tr key={row.id}>
                          <td>{row.facturaUnidad || "-"}</td>
                          <td>{row.fechaFactura || "-"}</td>
                          <td className="col-cliente">{row.cliente || "-"}</td>
                          <td className="col-cliente">{row.vendedor || "-"}</td>
                          <td className="col-producto">
                            {row.vehiculo || "-"}
                          </td>
                          <td>{row.vin || "-"}</td>
                          <td>{row.inventario || "-"}</td>
                          <td>{row.pedido || "-"}</td>
                          <td>{row.motor || "-"}</td>
                          <td className="text-end">
                            {formatMoney(row.subtotal)}
                          </td>
                          <td className="text-end">{formatMoney(row.iva)}</td>
                          <td className="text-end">{formatMoney(row.total)}</td>
                          <td className="col-producto">
                            {row.folioCfdi || "-"}
                          </td>
                          <td className="col-producto">{row.archivo || "-"}</td>
                          <td>
                            <span className={getBadgeClass(row.estatus)}>
                              {row.estatus}
                            </span>
                          </td>
                          <td className="col-observacion">
                            {row.observacion}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="16" className="text-center text-muted py-4">
                          No se encontraron facturas con los filtros aplicados.
                        </td>
                      </tr>
                    )}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan="9">Totales</th>
                      <th className="text-end">
                        {formatMoney(
                          facturasFiltradas.reduce(
                            (total, item) => total + Number(item.subtotal || 0),
                            0,
                          ),
                        )}
                      </th>
                      <th className="text-end">
                        {formatMoney(
                          facturasFiltradas.reduce(
                            (total, item) => total + Number(item.iva || 0),
                            0,
                          ),
                        )}
                      </th>
                      <th className="text-end">
                        {formatMoney(
                          facturasFiltradas.reduce(
                            (total, item) => total + Number(item.total || 0),
                            0,
                          ),
                        )}
                      </th>
                      <th colSpan="4" />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FacturacionFacturas;